import { useEffect, useState } from "react";
import moment from "moment";
import getCutoff from "client-sdk/src/orders/getCutoff";
import handleError from "../../../utils/handleError";

export const useCutoffHandler = ({
  courierId,
  dateSelected,
  fulfillmentTypeId,
  forceToFind,
  editMode,
  setDateInDatePiker,
  setValue,
}: {
  courierId: any;
  dateSelected: string;
  editMode: boolean;
  fulfillmentTypeId: any;
  forceToFind?: boolean;
  setValue: (name: string, value: any) => void;
  setDateInDatePiker: (date: string) => void;
}) => {
  const [listCutoff, setListCutoff] = useState<any[]>([]);

  const getFirstValidDate = (listcutoffformattedData: any[]) => {
    const now = new Date();
    const date = new Date();

    let isValidDateFound = true;
    const formattedDateNow = moment(now).format("YYYY-MM-DD HH:mm:ss");

    while (isValidDateFound) {
      const formattedDate = moment(date).format("YYYY-MM-DD");
      for (const cutoff of listcutoffformattedData) {
        const formattedTime = cutoff.startTime;
        const cvdd = `${formattedDate} ${formattedTime}`;
        const momentDate1 = moment(cvdd, "YYYY-MM-DD HH:mm:ss");
        const momentDate2 = moment(formattedDateNow, "YYYY-MM-DD HH:mm:ss");

        const handlerDistance = (Distance: string) => {
          switch (Distance) {
            case "HOURS":
              return "hours";
            case "MINUTES":
              return "minutes";
            case "DAYS":
              return "days";
            default:
              throw new Error("Unsupported unit");
          }
        };

        const difference = momentDate1.diff(
          momentDate2,
          handlerDistance(cutoff.acceptableDistanceUnit)
        );

        if (difference >= cutoff.acceptableDistance) {
          checkCutoff(cvdd, listcutoffformattedData);
          setDateInDatePiker(formattedDate);

          const smallDate = new Date(formattedDate);
          const dateSelect = new Date(dateSelected);
          if (dateSelect < smallDate) {
            if (!editMode) {
              setValue("deliveryDate", formattedDate);
            }
          }
          isValidDateFound = false;
          break;
        }
      }
      date.setDate(date.getDate() + 1);
    }
  };

  const checkCutoff = (cvdd: string, getListCutoff: any[]) => {
    const updatedList = getListCutoff.map((item) => {
      const formattedTime = item.startTime;
      const dateNow = `${dateSelected} ${formattedTime}`;
      const date1 = moment(dateNow);
      const date2 = moment(cvdd);

      return {
        ...item,
        disableCutoff: date1.isSameOrAfter(date2),
      };
    });

    setListCutoff(updatedList);
  };

  useEffect(() => {
    const handlerGetCutoff = async () => {
      if (courierId && fulfillmentTypeId && dateSelected) {
        try {
          const { res, ok } = await getCutoff(
            dateSelected,
            courierId,
            fulfillmentTypeId,
            forceToFind
          );
          if (ok) {
            const listcutoffformattedData = res.map((item: any) => ({
              ...item,
              value: `${item.startTime.split(":")[0]}-${
                item.endTime.split(":")[0]
              }`,
              label: `${parseInt(item.startTime.split(":")[0])} الی ${parseInt(
                item.endTime.split(":")[0]
              )}`,
            }));

            setListCutoff(listcutoffformattedData);
            getFirstValidDate(listcutoffformattedData);
          } else {
            setListCutoff([]);
          }
        } catch (error) {
          handleError(error);
        }
      }
    };

    handlerGetCutoff();
  }, [courierId, dateSelected, fulfillmentTypeId]);

  return { listCutoff };
};
